import React, { FC } from 'react';
import { SocialSignInWrapper, SocialSignInText } from '../../AuthModal.styles';
import { ButtonWithIcon } from '@blueprint/ui';
import triggerTracking from '@blueprint/tracking';

import { FacebookColourMedium, GoogleColourMedium } from '@blueprint/icons';

type SocialCopy = {
    cta: string;
    facebook: string;
    google: string;
};

type SocialAuthProps = {
    onFacebookLogin: () => void;
    onGoogleLogin: () => void;
    copy: SocialCopy;
    type: 'signin' | 'register';
};

const SocialAuth: FC<SocialAuthProps> = ({
    onFacebookLogin,
    onGoogleLogin,
    copy,
    type
}) => {
    return (
        <SocialSignInWrapper className="social-login">
            <SocialSignInText color="grey-steel" size="secondary">
                {copy.cta}
            </SocialSignInText>
            <ButtonWithIcon
                variant="secondary"
                isFullWidth
                data-testid={`${type}-google`}
                onClick={() => {
                    onGoogleLogin();
                    triggerTracking({
                        event: 'GAEvent',
                        eventCategory: type,
                        eventAction: 'click',
                        eventLabel: 'google'
                    });
                }}
            >
                <GoogleColourMedium />
                {copy.google}
            </ButtonWithIcon>
            <ButtonWithIcon
                variant="secondary"
                isFullWidth
                data-testid={`${type}-facebook`}
                onClick={() => {
                    onFacebookLogin();
                    triggerTracking({
                        event: 'GAEvent',
                        eventCategory: type,
                        eventAction: 'click',
                        eventLabel: 'facebook'
                    });
                }}
            >
                <FacebookColourMedium />
                {copy.facebook}
            </ButtonWithIcon>
        </SocialSignInWrapper>
    );
};

export default SocialAuth;
